module.exports = __webpack_public_path__ + "static/media/tca.16b4fb16.jpg";